import axios from 'axios'
import qs from 'qs'
import globalVar from './globalVar'
// import storage from './storage'
const codeMsg = {
  200: '服务器成功返回请求的数据。',
  // 201: '新建或修改数据成功。',
  // 202: '一个请求已经进入后台排队（异步任务）。',
  // 204: '删除数据成功。',
  // 400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  // 401: '用户没有权限（令牌、用户名、密码错误）。',
  // 403: '用户得到授权，但是访问是被禁止的。',
  // 404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  // 406: '请求的格式不可得。',
  // 410: '请求的资源被永久删除，且不会再得到的。',
  // 422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  // 502: '网关错误。',
  // 503: '服务不可用，服务器暂时过载或维护。',
  // 504: '网关超时。',
}

export function http(url,options,isHost = true){
  // console.log(process.env.NODE_ENV == 'production')
  // console.log('process.env.BASEURL',globalVar.httpType+process.env.BASEURL)
  const Host = isHost ? (globalVar.httpType+process.env.BASEURL) : ''
  // const Host = isHost ? (globalVar.httpType+process.env.BASEURL) : ''
  // console.log('Host',Host)
  const defaultOptions = {url:Host+url,timeout:20000}
  const newOptions = { ...defaultOptions, ...options}

  // if(isAddToken) newOptions.headers = {'ACCESS-TOKEN':storage.get('TOKEN'),...newOptions.headers}

  if(newOptions.method !== 'get'){
    newOptions.data = qs.stringify(newOptions.data)
    newOptions.headers = {'Content-Type':'application/x-www-form-urlencoded',...newOptions.headers}
  }

  return axios(newOptions)
    // .then(checkStatus)
    .then(response =>{
      return response.data
    })
    .catch(function (error) {
      console.warn(error.message)
    })
    // .then(checkCode)
}

export function post(url, data) {
  return http(url,{method:'post',data})
}

export function get(url, params = {}) {
  return http(url,{method:'get',params:params})
}


// function checkStatus(response) {
//   console.log('checkStatus',response)
//   if (response.status >= 200 && response.status < 300) {
//     return response;
//   }
//   const errortext = codeMsg[response.status] || response.statusText
//   console.warn('errortext',errortext)
//   return response
// }

// function checkCode(response){
//   console.log('response',response.data)
//   return response.data
// }



// WEBPACK FOOTER //
// ./src/util/http.js